export class UserHelper {
    static getNameAndInitial(firstname, lastname) {
        return (
            (firstname && firstname?.length > 0 ? firstname.trim() : "") +
            " " +
            (lastname && lastname?.length > 0 ? lastname.trim().charAt(0).toUpperCase() + "." : "")
        ).trim();
    }
}
